// Copyright (c) 2017 Deere & Company

import actions from '../actions-list';

export const selectAllDealers = dealers => ({
    dealers,
    type: actions.SELECT_ALL_ADVANCED_CLAIM_SUMMARY_DEALERS
});

export const selectAllDealersOnLoad = dealers => ({
    dealers,
    type: actions.SELECT_ALL_ADVANCED_CLAIM_SUMMARY_DEALERS_ON_LOAD
});

export const selectDealer = (dealer, isSelected) => ({
    dealer,
    isSelected,
    type: actions.SELECT_ADVANCED_CLAIM_SUMMARY_DEALER
});



// WEBPACK FOOTER //
// ./src/reports/advanced-claim-summary/action-creators/dealer-selection.js